import { type FC } from "react";
import { useTranslation } from "react-i18next";
import "./AiGeneratingCampaignLoader.scss";

const GENERATING_KEY = "campaignFlow.aiWizard.generatingCampaign";

const AiGeneratingCampaignLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="ai-generating-campaign">
      <div className="ai-generating-campaign__spinner" aria-hidden />
      <h3 className="ai-generating-campaign__title">{t(`${GENERATING_KEY}.title`)}</h3>
      <p className="ai-generating-campaign__subtitle">{t(`${GENERATING_KEY}.subtitle`)}</p>
      <div className="ai-generating-campaign__divider" />
      <p className="ai-generating-campaign__note">{t(`${GENERATING_KEY}.note`)}</p>
    </div>
  );
};

export default AiGeneratingCampaignLoader;
